import { useEffect } from "react";
import NavigationLayout from "../navigation/navigationLayout";
import AboutView from "./aboutView";
import FooterLayout from '../footer/footerLayout';

const AboutUsLayout = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            <NavigationLayout />

            <AboutView />

            <FooterLayout />
        </>
    );
}

export default AboutUsLayout;